import React, { useEffect } from "react";
import { Row, Col, Card, Divider, Tabs } from "antd";
import { HighlightOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { SugestaoDetalhes } from "./components/detalhes";
import { SugestoesAnexos } from "./components/anexos";
import { SugestoesAvaliar } from "./components/avaliar";
import http from "../../../services/http";

export const SugestoesAvaliacao = () => {
  const { id_sugestao } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id_sugestao > 0) {
      carregarSugestao(id_sugestao);
    } else {
      navigate("/sugestoes-recebidas");
    }
  }, [id_sugestao]);

  // CARREGAR SUGESTÃO
  const carregarSugestao = async (id) => {
    if (!id) return;
    const api = await http("get", `v1/sugestoes/carregar/${id}`, []);
    if (api.statusCode !== 200) {
      navigate("/sugestoes-recebidas");
    }
  };

  const items = [
    {
      key: "1",
      label: `Sugestão`,
      children: <SugestaoDetalhes idSugestao={id_sugestao} />,
    },
    {
      key: "2",
      label: `Anexos`,
      children: <SugestoesAnexos idSugestao={id_sugestao} />,
    },
    {
      key: "3",
      label: `Avaliar`,
      children: <SugestoesAvaliar idSugestao={id_sugestao} onFinish={() => navigate("/sugestoes-recebidas")} />,
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/sugestoes-recebidas")} />
            <HeaderTitle
              title="Sugestões Avaliação"
              subtitle="Realizar avaliação da sugestão"
              icon={<HighlightOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Tabs defaultActiveKey="1" items={items} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
